export default {
    navigationBarTitleText: "选择角色",
  };
  